import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const endSearchConversation = action('endSearchConversation', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));

export default endSearchConversation;
